import React from "react";
import ReactCardFlip from "react-card-flip";

import BusinessCardBackSide from "./BusinessCardBackSide.";
import BusinessCardFrontSide from "./BusinessCardFrontSide";

function SelectBusinessQRCard({
  rotate,
  material,
  materialcolor,
  materialFavoriteColor,
  imgPre,
  formValues,
  textColor,
  cardColor,
  productDetails
}) {
  // console.log(materialcolor,'materialcolor');
  // console.log(materialFavoriteColor,'materialFavoriteColor');
  // console.log(productDetails,'product details');
  const zeeqr = (
    <svg
      width="150"
      height="90"
      viewBox="0 0 641 272"
      style={{ color: `${textColor ? textColor : "white"}` }}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M60.3472 240.339C60.1203 235.894 59.8934 232.338 59.6664 229.005C58.3049 204.558 57.8511 180.333 59.6664 155.887C60.5741 145.219 61.4818 134.551 63.5241 124.106C65.1125 115.883 68.0625 107.66 70.3317 99.437C71.0125 96.7701 72.8279 96.3256 75.324 97.4368C82.8124 100.548 88.7123 105.882 93.4777 112.105C99.8314 120.55 103.916 130.106 105.278 140.774C105.504 141.663 105.958 142.552 106.412 143.663C114.127 134.774 113.901 124.55 106.412 115.661C99.8314 108.104 91.6623 102.771 82.3585 98.9925C73.5086 95.2144 66.701 87.4359 69.651 76.3237C69.8779 75.2125 69.1971 73.6568 68.5164 72.5456C63.2972 65.8783 61.028 57.8776 59.2126 49.8768C58.9857 49.2101 57.8511 42.9873 57.8511 42.3206C59.2126 45.8764 59.4395 50.7658 65.3395 54.7662C68.7433 56.9886 72.1471 57.8776 76.0047 57.2108C84.6277 55.6551 93.2507 54.5439 101.874 56.3219C105.504 56.9886 108.681 59.211 112.085 60.7667C113.674 61.4334 115.489 62.3224 117.077 62.5447C138.408 64.9893 159.739 67.2118 181.069 69.4342C184.246 69.8787 190.827 70.7676 190.827 70.9899C187.65 71.4344 184.7 71.8789 181.523 72.1011C161.1 74.5458 140.677 76.7682 120.254 79.4351C117.985 79.6574 115.716 80.5463 113.674 81.4353C107.32 84.1022 106.639 90.7695 112.312 94.7699C123.204 102.771 130.466 112.772 132.508 126.106C134.55 139.885 131.373 152.775 123.204 163.887C118.666 170.11 112.993 175.444 108.001 181.445C106.639 183.223 105.731 185.667 105.051 187.89C103.008 195.001 101.647 202.335 98.9238 209.003C95.293 217.892 90.7546 226.56 86.2162 235.227C79.1816 248.34 59.8934 271.675 59.4395 271.897C59.4395 271.008 59.2126 270.342 59.2126 269.453C59.2126 256.785 61.2549 244.562 64.6587 232.338C68.5164 218.781 74.1894 206.114 83.4931 195.668C87.5777 191.001 92.57 187.223 97.5622 183.223C100.058 181.222 101.42 179.667 101.193 176.333C101.193 170.332 101.647 164.332 101.647 158.331C101.647 157.22 101.42 156.331 101.42 154.331C97.5622 157.665 94.3853 160.332 91.4354 163.443C81.2239 173.666 72.1471 184.556 67.1548 198.335C65.3395 203.002 64.4318 208.114 63.751 213.225C62.8433 221.226 60.801 238.783 60.3472 240.339ZM107.32 174.333C107.547 174.555 107.774 174.555 108.228 174.777C111.177 171.444 114.127 168.332 116.851 164.776C126.608 151.886 130.92 137.663 126.381 121.439C123.431 111.438 116.851 104.104 108.454 98.1035C102.781 94.1031 101.874 84.9912 106.866 80.5463C109.589 78.1017 113.447 76.3237 117.077 75.2125C121.616 73.879 126.608 73.6568 131.373 73.2123C135.004 72.7678 138.635 72.3233 142.266 71.8789C142.266 71.6566 142.266 71.2121 142.266 70.9899C137.727 70.5454 132.962 70.1009 128.423 69.4342C123.204 68.7675 117.985 68.323 112.993 67.434C109.362 66.7673 105.731 65.2116 101.874 64.7671C91.4354 63.4336 82.8124 66.9895 76.6855 75.4347C74.6432 78.1017 74.1894 81.2131 75.0971 84.7689C76.6855 90.7695 81.4508 93.2142 86.4431 95.4366C95.293 99.437 103.462 104.326 110.043 111.883C120.027 123.439 121.616 135.218 111.631 146.775C108.228 150.775 107.774 154.109 107.774 158.331C107.774 158.776 107.774 159.443 107.774 159.887C107.32 164.554 107.32 169.443 107.32 174.333ZM64.2049 191.446C66.9279 186.778 69.1971 183 71.4663 179.444C79.1816 167.888 88.7123 158.109 99.6045 149.442C100.512 148.775 101.42 147.441 101.193 146.552C99.1507 139.218 97.5622 131.662 94.6123 124.55C91.2085 116.105 85.3085 109.438 77.3663 104.549C75.0971 103.215 74.1894 103.437 73.5086 106.104C72.1471 111.438 70.3317 116.55 69.651 121.661C67.8356 132.773 66.4741 143.886 65.1125 155.22C64.4318 161.887 64.2049 168.554 64.2049 175.444C63.9779 180.333 64.2049 185.445 64.2049 191.446ZM66.0202 255.674C81.9047 235.672 94.1584 213.892 99.6045 188.556C76.9124 205.447 69.1971 229.449 66.0202 255.674Z" />
      <path d="M217.83 106.993C217.376 157.886 180.842 201.224 130.011 211.225C126.154 212.114 122.069 212.114 117.984 212.78C115.488 213.225 115.034 211.225 114.808 209.669C114.808 209.002 116.623 207.891 117.531 207.669C148.165 205.002 172.672 191.445 191.28 167.665C201.718 154.331 208.072 138.996 211.022 122.328C213.518 106.548 212.61 90.7691 207.164 75.8788C193.095 37.4308 165.638 13.2063 123.884 6.98354C87.3501 1.42747 56.4889 13.2063 31.5276 39.8755C20.6354 51.6544 13.3739 65.4334 8.83547 80.7682C4.7509 94.9917 4.07013 109.882 6.79319 124.106C12.0124 151.219 26.0815 173.221 49.2274 189.445C49.9082 189.889 50.8158 190.778 50.8158 191.445C50.8158 192.556 50.362 193.89 49.4543 194.557C49.0005 195.001 47.412 194.556 46.7313 193.89C34.0237 185.222 23.8123 174.332 15.6431 161.442C8.83547 150.775 4.29706 138.996 2.02785 126.772C-0.241362 115.438 -0.695204 103.881 1.12016 92.1026C4.7509 68.7671 14.5085 48.7652 31.3006 32.097C46.9582 16.3177 66.2465 6.31682 88.2578 2.0942C113.219 -2.79514 136.819 0.98299 159.284 12.3174C179.707 22.7628 195.138 38.0975 205.576 58.3216C211.249 69.2115 215.107 80.5459 216.241 92.547C216.695 97.8809 217.149 102.326 217.83 106.993Z" />
      <path d="M328.113 67.2109L289.99 123.216H328.113V137.217H270.248V124.327L308.144 68.3221H270.248V54.3208H328.113V67.2109Z" />
      <path d="M394.147 67.8776H361.925V88.7684H390.517V101.881H361.925V123.883H394.147V137.44H344.906V54.3208H394.147V67.8776Z" />
      <path d="M461.089 67.8776H428.866V88.7684H457.458V101.881H428.866V123.883H461.089V137.44H411.847V54.3208H461.089V67.8776Z" />
      <path d="M543.688 130.551L563.203 151.886H542.1L529.165 136.773C525.761 137.662 521.904 138.107 518.273 138.107C494.446 138.107 474.931 120.55 474.931 95.6585C474.931 70.7673 494.446 53.2101 518.273 53.2101C542.327 53.2101 561.615 70.7673 561.615 95.6585C561.615 110.771 554.58 123.217 543.688 130.551ZM518.273 123.439C533.477 123.439 544.142 112.549 544.142 95.6585C544.142 78.768 533.477 68.1004 518.273 68.1004C502.842 68.1004 492.404 78.768 492.404 95.6585C492.404 112.549 502.842 123.439 518.273 123.439Z" />
      <path d="M608.814 54.3208C629.237 54.3208 639.448 65.8774 639.448 79.6565C639.448 89.6574 633.775 99.8806 620.16 103.659L640.356 137.217H620.614L602.006 104.992H594.064V137.217H577.045V54.3208H608.814ZM608.133 68.0999H593.837V92.5466H608.133C617.664 92.5466 621.749 87.6572 621.749 80.101C621.749 72.767 617.664 68.0999 608.133 68.0999Z" />
      <path d="M278.645 172.555C282.503 172.555 284.545 174.777 284.545 177.444C284.545 179.444 283.41 181.444 280.914 182.111L284.772 188.556H280.914L277.283 182.333H275.695V188.556H272.518V172.555H278.645ZM278.418 175.222H275.695V179.889H278.418C280.233 179.889 281.141 179 281.141 177.444C281.141 176.111 280.233 175.222 278.418 175.222Z" />
      <path d="M300.883 175.222H294.756V179.222H300.202V181.667H294.756V185.889H300.883V188.556H291.352V172.555H300.883V175.222Z" />
      <path d="M321.987 172.555V188.556H318.81L311.322 177.666V188.556H308.145V172.555H311.322L318.81 183.667V172.555H321.987Z" />
      <path d="M336.736 188.778C332.198 188.778 328.34 185.445 328.34 180.555C328.34 175.666 332.198 172.332 336.736 172.332C341.502 172.332 345.132 175.666 345.132 180.555C344.906 185.445 341.275 188.778 336.736 188.778ZM336.736 185.889C339.686 185.889 341.729 183.889 341.729 180.555C341.729 177.222 339.686 175.221 336.736 175.221C333.786 175.221 331.744 177.222 331.744 180.555C331.744 183.889 333.786 185.889 336.736 185.889Z" />
      <path d="M362.605 172.555H366.009L360.109 188.556H356.025L350.125 172.555H353.529L358.067 185.223L362.605 172.555Z" />
      <path d="M382.121 185.445H375.54L374.406 188.556H371.002L376.902 172.555H380.76L386.66 188.556H383.256L382.121 185.445ZM378.717 176.333L376.448 183H381.213L378.717 176.333Z" />
      <path d="M391.878 172.555H403.905V175.222H399.594V188.556H396.417V175.222H392.105V172.555H391.878Z" />
      <path d="M410.258 172.555H413.435V188.556H410.258V172.555Z" />
      <path d="M434.767 172.555V188.556H431.59L424.101 177.666V188.556H420.925V172.555H424.101L431.59 183.667V172.555H434.767Z" />
      <path d="M457.005 177.444H453.147C452.466 176.11 451.105 175.444 449.29 175.444C446.34 175.444 444.297 177.444 444.297 180.777C444.297 184.111 446.34 186.111 449.29 186.111C451.786 186.111 453.374 184.778 453.828 182.333H448.155V179.888H457.005V182.778C456.324 186.111 453.374 189 449.063 189C444.297 189 440.667 185.667 440.667 180.777C440.667 175.888 444.297 172.554 449.063 172.554C453.147 172.332 455.87 174.11 457.005 177.444Z" />
      <path d="M472.434 172.555H484.461V175.222H480.15V188.556H476.973V175.222H472.661V172.555H472.434Z" />
      <path d="M501.027 181.667H493.993V188.556H490.816V172.555H493.993V179.222H501.027V172.555H504.204V188.556H501.027V181.667Z" />
      <path d="M520.997 175.222H514.87V179.222H520.316V181.667H514.87V185.889H520.997V188.556H511.466V172.555H520.997V175.222Z" />
      <path d="M537.562 172.555H547.546V175.222H540.739V179.222H545.958V181.667H540.739V188.334H537.562V172.555Z" />
      <path d="M553.899 172.555H557.076V182.556C557.076 184.778 558.21 185.889 560.48 185.889C562.522 185.889 563.883 184.778 563.883 182.556V172.555H567.287V182.333C567.287 186.556 564.11 188.556 560.707 188.556C557.303 188.556 554.126 186.556 554.126 182.333V172.555H553.899Z" />
      <path d="M573.415 172.555H585.442V175.222H581.13V188.556H577.953V175.222H573.642V172.555H573.415Z" />
      <path d="M591.569 172.555H594.746V182.556C594.746 184.778 595.881 185.889 598.15 185.889C600.192 185.889 601.554 184.778 601.554 182.556V172.555H604.958V182.333C604.958 186.556 601.781 188.556 598.377 188.556C594.973 188.556 591.796 186.556 591.796 182.333V172.555H591.569Z" />
      <path d="M618.118 172.555C621.976 172.555 624.018 174.777 624.018 177.444C624.018 179.444 622.883 181.444 620.387 182.111L624.245 188.556H620.387L616.757 182.333H615.168V188.556H611.991V172.555H618.118ZM617.891 175.222H615.168V179.889H617.891C619.707 179.889 620.614 179 620.614 177.444C620.614 176.111 619.707 175.222 617.891 175.222Z" />
      <path d="M640.356 175.222H634.229V179.222H639.675V181.667H634.229V185.889H640.356V188.556H630.825V172.555H640.356V175.222Z" />
      <defs>
        <linearGradient
          id="paint0_linear_1260_420"
          x1="-15.6039"
          y1="100.883"
          x2="548.556"
          y2="292.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1260_420"
          x1="-15.6046"
          y1="100.882"
          x2="548.555"
          y2="292.479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1260_420"
          x1="31.6169"
          y1="-38.1625"
          x2="595.777"
          y2="153.435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1260_420"
          x1="31.6172"
          y1="-38.1624"
          x2="595.777"
          y2="153.435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1260_420"
          x1="31.617"
          y1="-38.1624"
          x2="595.777"
          y2="153.435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1260_420"
          x1="31.6171"
          y1="-38.1619"
          x2="595.777"
          y2="153.435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1260_420"
          x1="31.6169"
          y1="-38.1625"
          x2="595.777"
          y2="153.434"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1260_420"
          x1="27.6913"
          y1="40.8928"
          x2="555.186"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1260_420"
          x1="27.6911"
          y1="40.8928"
          x2="555.186"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1260_420"
          x1="27.6909"
          y1="40.8928"
          x2="555.187"
          y2="220.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1260_420"
          x1="27.6904"
          y1="40.8926"
          x2="555.186"
          y2="220.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1260_420"
          x1="27.6908"
          y1="40.8928"
          x2="555.186"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1260_420"
          x1="27.6908"
          y1="40.8928"
          x2="555.187"
          y2="220.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1260_420"
          x1="27.6909"
          y1="40.8928"
          x2="555.186"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1260_420"
          x1="27.6917"
          y1="40.8928"
          x2="555.185"
          y2="220.037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1260_420"
          x1="27.6908"
          y1="40.8928"
          x2="555.187"
          y2="220.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1260_420"
          x1="27.6904"
          y1="40.8925"
          x2="555.187"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1260_420"
          x1="27.6898"
          y1="40.8928"
          x2="555.185"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1260_420"
          x1="27.6912"
          y1="40.8928"
          x2="555.186"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1260_420"
          x1="27.6917"
          y1="40.8928"
          x2="555.187"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1260_420"
          x1="27.6919"
          y1="40.8927"
          x2="555.187"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1260_420"
          x1="27.6891"
          y1="40.8928"
          x2="555.185"
          y2="220.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1260_420"
          x1="27.6888"
          y1="40.8928"
          x2="555.186"
          y2="220.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_1260_420"
          x1="27.6921"
          y1="40.8928"
          x2="555.187"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_1260_420"
          x1="27.6912"
          y1="40.8928"
          x2="555.186"
          y2="220.038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_1260_420"
          x1="27.6927"
          y1="40.8928"
          x2="555.186"
          y2="220.037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDB34A" />
          <stop offset="0.2793" stopColor="#C5AC5A" />
          <stop offset="0.5251" stopColor="#E1D5A1" />
          <stop offset="0.8045" stopColor="#C5AC5A" />
          <stop offset="1" stopColor="#DBB24B" />
        </linearGradient>
      </defs>
    </svg>
  );
const width= '350px'
  const filterData = productDetails?.CustomCardColor?.[material]?.filter((data) => (data.value === materialcolor))
  const filterDataImg = productDetails?.CustomTextColor?.[materialcolor]?.filter((data) => (data.value === materialFavoriteColor))
  // console.log(filterData);
  // console.log(filterDataImg,'filterDataImg');

  return (
    <ReactCardFlip isFlipped={rotate} flipDirection="horizontal">
      <div className="relative w-[300px] sm:w-[350px]">
        {filterDataImg && filterDataImg[0] && filterDataImg[0]?.images ? (
          <img src={filterDataImg[0]?.images?.BusniessQR} className={`w-[${width}]`} alt=""></img>
        ) : (
          <BusinessCardBackSide
            formValues={formValues}
            cardColor={cardColor}
            textColor={textColor}
          />
        )}
        
        <div
          className="absolute bottom-8 left-5 flex flex-col  justify-center text-white"
          style={{ color: `${textColor ? textColor : "white"}` }}
        >
          <h3
            className=" font-bold "
            style={{
              fontSize: `${formValues?.name?.length >= 18
                ? "12px"
                : formValues?.name?.length >= 12
                  ? "14px"
                  : "20px"
                }`,
            }}
          >
            {formValues?.name ? formValues?.name : "ZEEQR"}
          </h3>
          <span
            className="text-xs "
            style={{
              fontSize: `${formValues?.name?.length >= 18 ||
                formValues?.tagline?.length >= 20
                ? "10px"
                : formValues?.name?.length >= 12 ||
                  formValues?.tagline?.length >= 16
                  ? "12px"
                  : "18px"
                }`,
            }}
          >
            {formValues?.tagline ? formValues?.tagline : "Tagline"}
          </span>
        </div>
        {/* } */}
      </div>
      <div className="relative">
        {filterDataImg && filterDataImg[0] && filterData[0]?.images ? (
          <img src={filterData[0]?.images?.BusniessQR} className={`w-[${width}]`} alt=""></img>
        ) : (
          <BusinessCardFrontSide
            cardColor={cardColor}
            textColor={textColor}
            imgPre={imgPre}
          />
        )}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  text-left">
          {material !== 'PVC_NC' && imgPre ? (
            <img className="w-40" src={imgPre} alt="" srcset="" />
          ) : (
            zeeqr
          )}
        </div>
      </div>
    </ReactCardFlip>
  );
}

export default SelectBusinessQRCard;
